import React from 'react';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
/* replace-start-value = import { getChildrenToRender } from './utils'; */
import { getChildrenToRender } from '../../utils';
/* replace-end-value */
/* replace-start */
import './index.less';
/* replace-end */
class Feature98 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;
    const animType = {
      queue: 'bottom',
      one: {
        y: '+=100', opacity: 0, type: 'from', ease: 'easeOutQuad',
      },
    };

    function setHtml(data) {
      return data.map((value, index) => {
        return (
          <QueueAnim
            key={index}
            leaveReverse
            ease={['easeOutQuad', 'easeInQuad']}
            {...value}
            data-edit="text"
          >
            {
              value.children.map(getChildrenToRender)
            }
          </QueueAnim>
        );
      });
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div
          {...dataSource.page}
        >
          <div {...dataSource.content}>
            <div className="left">
              <QueueAnim
                key="text"
                type={animType.queue}
                leaveReverse
                ease={['easeOutQuad', 'easeInQuad']}
                {...dataSource.childWrapper}
                componentProps={{ md: dataSource.childWrapper.md, xs: dataSource.childWrapper.xs }}
                data-edit="text"
              >
                {
              dataSource.childWrapper.children.map(getChildrenToRender)
            }
              </QueueAnim>
              {
              setHtml(dataSource.content.children)
            }
            </div>
            <div className="right">
              <TweenOne
                animation={animType.one}
                key="title"
                {...dataSource.image}
              >
                <img src={dataSource.image.children} width="100%" alt="img" />
              </TweenOne>
            </div>

          </div>
        </div>
      </OverPack>
    );
  }
}
export default Feature98;
